import React from 'react';
import { formatDollar } from '../../../utils/CurrencyFormatter';
import { Text, Grid, Heading } from '@chakra-ui/core';

const TotalSummary = ({ totalAcreage, totalExpenses, totalYield }) => {
  return (
    <Grid templateColumns="repeat(3, 1fr)" mt={8}>
      <Heading
        as="h6"
        textAlign="center"
        borderRightWidth={1}
        borderRightColor="cf.400"
        px={{ base: 2, lg: 4 }}
      >
        {totalAcreage}{' '}
        <Text as="span" d="block" fontSize={{ base: 'tiny', md: 12 }} fontWeight="normal">
          Total Acres Owned
        </Text>
      </Heading>

      <Heading
        as="h6"
        textAlign="center"
        borderRightWidth={1}
        borderRightColor="cf.400"
        px={{ base: 2, lg: 4 }}
      >
        {formatDollar(totalExpenses)}{' '}
        <Text as="span" d="block" fontSize={{ base: 'tiny', md: 12 }} fontWeight="normal">
          Total paid
        </Text>
      </Heading>

      <Heading as="h6" textAlign="center" px={{ base: 2, lg: 4 }}>
        {totalYield}{' '}
        <Text as="span" d="block" fontSize={{ base: 'tiny', md: 12 }} fontWeight="normal">
          Total Estimated Yield
        </Text>
      </Heading>
    </Grid>
  );
};

export default TotalSummary;
